module.exports = __webpack_public_path__ + "img/logo-renault-black.d5492e64.svg";